(function() {
  var BaseHandler, BaseOutput, DetailOutput,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  DetailOutput = App.loadClass('core::reports/DetailOutput');

  BaseOutput = App.loadClass('core::reports/BaseOutput');

  BaseHandler = App.loadClass('core::reports/BaseHandler');

  exports.ReportsPlotsSubHandler = (function(superClass) {
    extend(ReportsPlotsSubHandler, superClass);

    function ReportsPlotsSubHandler() {
      return ReportsPlotsSubHandler.__super__.constructor.apply(this, arguments);
    }

    ReportsPlotsSubHandler.prototype.init = function() {
      this.layoutSelector = '#reports_plots_tab';
      this.filterUrl = 'backend/portal/reports/plots/filters';
      this.parent.dialog.find('.excel-btn').hide();
      return this.initFilters();
    };

    ReportsPlotsSubHandler.prototype.initFilters = function() {
      this.resetFilters();
      this.parent.filters.importGroup({
        name: 'Plots Filters',
        filters: [
          {
            name: 'brands',
            display_name: 'Brand',
            "class": 'dropup'
          }, {
            name: 'test_types',
            display_name: 'Test Type',
            "class": 'dropup'
          }, {
            name: 'output_type',
            display_name: 'Output Type',
            control_type: 'option',
            deletable: false,
            values: [
              {
                key: 'detail',
                value: 'Detail'
              }, {
                key: 'summary',
                value: 'Summary'
              }
            ],
            selected_values: [
              {
                key: 'detail',
                value: 'Detail'
              }
            ]
          }
        ]
      });
      return this.setDefaultsAndRun(-1);
    };

    ReportsPlotsSubHandler.prototype.destroy = function() {
      this.parent.filters.removeGroup('Plots Filters');
      this.parent.dialog.find('.excel-btn').show();
      return ReportsPlotsSubHandler.__super__.destroy.call(this);
    };

    ReportsPlotsSubHandler.prototype.beforeApply = function() {
      var filters;
      filters = this.parent.filters.jsonize();
      if (filters.filters.output_type[0].key === 'detail') {
        this.layoutUrl = 'backend/portal/reports/plots/table/detail';
        this.printUrl = 'backend/portal/reports/plots/print/detail';
        return this.currentOutput = new DetailOutput(this, this.parent, 900, {
          sAjaxSource: 'backend/portal/reports/plots/output/detail'
        });
      } else {
        this.layoutUrl = 'backend/portal/reports/plots/output/summary';
        this.printUrl = 'backend/portal/reports/plots/print/summary';
        return this.currentOutput = new BaseOutput(this, this.parent, 900);
      }
    };

    return ReportsPlotsSubHandler;

  })(BaseHandler);

}).call(this);
